import React, {useState, useEffect, useContext} from 'react';
import AppContext from '../../context/Context';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/illustrations/falcon.png';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';

const Logo = ({ at, width, className, textClass, ...rest }) => {
  const [collapse, setCollapse] = useState(false);
  const {
    config: {isNavbarVerticalCollapsed },
  } = useContext(AppContext);

  useEffect(() => {
    if (isNavbarVerticalCollapsed !== undefined) {
      setCollapse(isNavbarVerticalCollapsed)
    }
  }, [isNavbarVerticalCollapsed])

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center logo-vertical': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-1" src={logo} alt="Logo" width={width} />
        {!collapse &&
            <span className={classNames(textClass, `d-${topNavbarBreakpoint}-block d-none`)} style={{ fontSize: '1.4rem'}}>FNOTrader</span>
        }
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  isNavbarVerticalCollapsed: PropTypes.bool,
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
